import React, { useEffect, useState } from 'react';

import { ActionIcon, Button, Group, Stack } from '@mantine/core';
import { IconPlayerPlay, IconRefresh, IconPlayerPause } from '@tabler/icons-react';

import CountdownOptions from './CountdownOptions';
import { useCountdownTimer } from './useCountdownTimer';
import DisplayTime from '../DisplayTime';
import { formatMilisecondsToMMSS } from '../format';

function Countdown(): JSX.Element {
  const [countdownPresetMinutes, setCountdownPresetMinutes] = useState<string>('10');
  const [countdownMinutes, setCountdownMinutes] = useState<number>(10);

  const { countdown, isRunning, start, reset, pause } = useCountdownTimer({
    timer: countdownMinutes * 60 * 1000,
  });

  const handlePresetChange = (value: string | null): void => {
    if (!value) return;
    setCountdownPresetMinutes(value);
    setCountdownMinutes(Number(value));
  };

  const handleCountdownMinutesChange = (value: number): void => {
    setCountdownMinutes(value || 1);
  };

  useEffect(() => {
    console.log('effect and reset');
    reset();
  }, [countdownMinutes, reset]);

  return (
    <Stack spacing='md'>
      <DisplayTime value={formatMilisecondsToMMSS(countdown)} />
      <CountdownOptions
        countdownPresetMinutesValue={countdownPresetMinutes}
        handlePresetChange={handlePresetChange}
        countdownMinutesValue={countdownMinutes}
        handleCountdownMinutesChange={handleCountdownMinutesChange}
      />

      <Group align='end' noWrap sx={{ width: '100%' }}>
        {isRunning && (
          <Button leftIcon={<IconPlayerPause size={18} />} onClick={pause} sx={{ flex: 1, minWidth: 0 }}>
            Pause
          </Button>
        )}

        {!isRunning && (
          <Button leftIcon={<IconPlayerPlay size={18} />} onClick={start} sx={{ flex: 1, minWidth: 0 }}>
            Start
          </Button>
        )}

        <ActionIcon
          size={36}
          variant='outline'
          color='gray'
          onClick={reset}
          aria-label='Reset timer'
          sx={{ flex: '0 0 auto' }}
        >
          <IconRefresh size={20} />
        </ActionIcon>
      </Group>
    </Stack>
  );
}

export default Countdown;
